<template>
  <div class="about ma-0 pa-0">
    <v-layout row wrap>
      <v-flex class="pa-0 ma-0" xs12 md8>
        <Carousel />
      </v-flex>
      <v-flex align-self-center class="py-4 px-2" xs12 md4>
        <h1>{{$t("about.title")}}</h1>
        <h3>
          {{$t("about.descBold")}}
        </h3>
        <br />
        <blockquote>
          {{$t("about.desc")}}
        </blockquote>
      </v-flex>
    </v-layout>
  </div>
</template>
<style>
.about {
  background: var(--background2);
  height: 600px;
}
</style>
<script>
import Carousel from "../components/Carousel";

export default {
  components: { Carousel },
  data() {
    return {
      items: [
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg"
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/sky.jpg"
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/bird.jpg"
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/planet.jpg"
        }
      ]
    };
  }
};
</script>
